import layoutActions from "actions/layout";
import React from "react";
import { connect } from "react-redux";
import { ToggleTheme } from "../theme";

export const Footer = (props) => {
    const { theme, toggleTheme, isLogin, displayVersion } = props;

    return (
        <footer className="page-layout__footer">
            {!isLogin && (
                <>
                    {displayVersion} &copy; Цифровизация транспорта, {new Date().getFullYear()} год.&nbsp;&nbsp;
                    <a
                        href="/license-agreement"
                        className="page-layout__footer--license-agreement text-white"
                        target="_blank"
                    >
                        Лицензионный договор
                    </a>
                </>
            )}
            <ToggleTheme toggleTheme={toggleTheme} theme={theme} />
        </footer>
    );
};

const mapStateToProps = (state) => ({
    theme: state.layout.theme,
    displayVersion: state.configs.displayVersion,
});

const mapDispatchToProps = (dispatch) => ({
    toggleTheme: () => dispatch(layoutActions.toggleTheme()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
